import { DefaultReplacePriceRepository } from '@/models/api/cart/latest-price/replace-price-reposiory'
import BehaviorConfig from '@/models/app-config/behavior/behavior'
import AppId from '@/util/appid'

export async function prepareCartBeforeAddToCart(brandEnglishName: string): Promise<void> {
  if (!BehaviorConfig.createFromBrand(brandEnglishName).paidMembership.enabled) {
    return
  }

  /**
   * 有料会員機能が有効な場合、会員価格/通常価格の別と購入可能数を正しく判定するため、
   * カート投入前に既存カート商品の価格を最新の有効価格へ更新しておく。
   */
  const result = await DefaultReplacePriceRepository
    .create(AppId.getByBrandName(brandEnglishName))
    .updateCurrentValidPrice()

  result.fold(
    (error) => {
      throw error
    },
    () => undefined
  )
}
